import { IconFolderPlus } from '@tabler/icons-react';
import axios from 'axios';

import { ActionIcon } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';

import { ProjectDto, ProjectUploadDto } from '../../api/models';
import { usePostApiProjects } from '../../api/projects/projects.ts';
import ProjectModal from './ProjectModal.tsx';

interface ProjectAddModalProps {
    refetch: () => Promise<ProjectDto[]>;
    existingProjects?: ProjectDto[];
}

const ProjectAddModal = ({
    refetch,
    existingProjects
}: ProjectAddModalProps) => {
    const { mutateAsync: addProject, error, isPending } = usePostApiProjects();
    const [opened, { open, close }] = useDisclosure();
    const handleAdd = async (data: ProjectUploadDto) => {
        try {
            await addProject({ data });

            notifications.show({
                title: 'Project Created',
                message: `${data.name} created! ✔️`,
                loading: false,
                withCloseButton: true,
                autoClose: 2000
            });
        } catch (err) {
            const errorMessage =
                axios.isAxiosError(err) && err.response
                    ? `Server error: ${err.response.status} ${err.response.statusText}`
                    : 'An unexpected error occurred ❌';

            notifications.show({
                title: 'Project Creation Failed',
                message: errorMessage,
                loading: false,
                withCloseButton: true,
                autoClose: 5000,
                color: 'red'
            });
        }
    };

    return (
        <>
            <ActionIcon
                variant='subtle'
                size={'md'}
                color='secondary'
                onClick={open}
                title='Add New Project'
                loading={isPending}
            >
                <IconFolderPlus />
            </ActionIcon>
            <ProjectModal
                opened={opened}
                onClose={close}
                onSubmit={handleAdd}
                error={error}
                isPending={isPending}
                refetch={refetch}
                title='Add Project'
                existingProjects={existingProjects}
            />
        </>
    );
};

export default ProjectAddModal;
